import React, { createContext, useContext, useState } from 'react';
import Snackbar from 'components/Snackbar/Snackbar';

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snacks, setSnacks] = useState([]);

  const showSnackbar = (message, type = 'info', duration = 4000) => {
    const id = Date.now() + Math.random();
    setSnacks((prev) => [...prev, { id, message, type, duration }]);
  };

  const removeSnackbar = (id) => {
    setSnacks((prev) => prev.filter((s) => s.id !== id));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar snacks={snacks} removeSnackbar={removeSnackbar} />
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar debe usarse dentro de SnackbarProvider');
  }
  return context;
};
